<script setup lang="ts">
defineProps<{
  text: string
}>()

const { styles } = useVariants('menuTitleBlock')
</script>

<template>
  <div :class="styles.base()">
    <h2 :class="styles.title()">
      {{ text }}
    </h2>
  </div>
</template>
